import React from "react";
import { FormattedMessage } from "react-intl";
import type { IIntegrationFormImplProps } from "src/integrations/forms/IIntegrationFormImplProps";
import { INTEGRATION_SHOPIFY_IS_POST_CHECKOUT_SUBSCRIBE } from "src/integrations/forms/shopify/IntegrationFormDataShopifyCheckout";
import { Tooltip } from "src/shared/formatters/Tooltip";
import { CheckboxInput } from "src/shared/forms/inputs/CheckboxInputOld";
import { InfoCircle } from "src/shared/icons/IconCircle";

export const ShopifyIsPostCheckoutSubscribe = ({
  isEdit,
}: IIntegrationFormImplProps) => {
  return (
    <CheckboxInput
      inputID={INTEGRATION_SHOPIFY_IS_POST_CHECKOUT_SUBSCRIBE}
      label={
        <FormattedMessage id="integrations.shopifyCheckouts.isPostCheckoutSubscribe" />
      }
      disabled={isEdit}
      tooltip={
        <Tooltip
          tag="span"
          isOpen
          tooltipProps={{ placement: "right" }}
          tooltipRender={
            <FormattedMessage id="integrations.shopifyCheckouts.isPostCheckoutSubscribe.tooltip" />
          }
        >
          <InfoCircle />
        </Tooltip>
      }
    />
  );
};
